import { ReactNode } from 'react';
import { cssWhen } from '../../utils/themeUtils';
import classes from './Dialog.module.scss';

type AbstractDialogProps = {
  header: ReactNode;
  content: ReactNode;
  footer: ReactNode;
  withHeaderDivider?: boolean;
  withFooterDivider?: boolean;
};

export const Dialog = ({ header, content, footer, withHeaderDivider, withFooterDivider }: AbstractDialogProps) => {
  return (
    <div className={classes.container}>
      <div className={cssWhen([withHeaderDivider, classes.headerDivider])}>{header}</div>
      <div className={classes.contentSection}>{content}</div>
      <div className={cssWhen([withFooterDivider, classes.footerDivider])}>{footer}</div>
    </div>
  );
};
